<template>
    <div class="container" @scroll="handleScroll">
        <div class="banner-img">
            <div class="b-txt">汇聚专业，探索无限可能</div>
        </div>
        <!-- us tab切换 -->
        <div class="us-tabs">
            <div :class="usIndex == index ? 'p-item-c' : ''" @click="usClick(index)" :key="index" class="p-item"
                v-for="(item, index) in tabs">{{
                    item }}</div>
        </div>
        <!-- 企业介绍 -->
        <div class="us-intr" ref="usIntr">
            <div class="us-tit">关于新域伟科技</div>
            <!-- <div class="us-tip">用科技创造教育公平，为员工实现自我价值</div> -->
            <div class="us-con">
                <p>
                    济南新域伟网络科技有限公司（简称：新域伟科技）于2019 年4 月份成立于美丽泉城-济南，公司专注于数智化管理平台的建设，
                    通过大数据、人工智能与教育及政企行业的深度融合，打造数智化管理平台，为客户提供数据共建共享的应用及服务。
                </p>
                <p>
                    服务涵盖局校数智化管理平台建设、政企数智化管理平台建设、中高职数据中台等应用建设；产品与阿里巴巴-钉钉、蚂蚁金服-支付宝、微信等平台均有深度的合作，团队具备服务运营能力、推广部署能力、产品开发和定制开发等综合能力。
                </p>
                <p>
                    公司自主研发的产品已服务的客户涵盖全国；截止2023年第四季度已服务全国数千家组织客户。同时与多家金融机构、运营商建立良好合作关系。
                    未来，新域伟科技将持续深耕组织数智化建设，为国家数智化新基建的建设发展贡献力量。
                </p>
            </div>
            <img src="https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/us-gs.png" alt="">
        </div>
        <!-- 证书 -->
        <div class="certificate" ref="certificate">
            <div class="certificate-tit">企业荣誉</div>
            <div class="cer-imgs">
                <img v-for="(item, index) in cerImgs" :key="index" class="cer-img" :src="item" alt="">
            </div>
        </div>
        <!-- boss -->
        <div class="boss-box" ref="bossBox">
            <div class="boss-left">
                <div class="b-l-name">邱文伟（挥笔）</div>
                <div class="b-l-tip">CEO</div>
            </div>
            <div class="boss-right">
                <div class="b-f-tit">总经理简介</div>
                <div class="b-f-tip"></div>
                <div class="b-f-con">
                    <p>
                        1981年生人 <span class="b-f-con-c">中国人民解放军信息工程大学毕业</span> 济南新域伟网络科技有限公司创始人
                    </p>
                    作为济南新域伟网络科技有限公司的创始人和掌舵人，他凭借对市场的敏锐洞察和技术的深入理解，成功地引领公司在本领域内崭露头角。在他的引领下，公司不仅在业界建立了良好的声誉，也获得了多项重要的行业认证和奖项。<br />
                    除了在公司的日常运营和管理中展现出卓越的领导才能外，邱文伟还积极参与社会活动和行业交流。他担任山东省福州商会副会长兼副秘书长，与各行业精英共同探讨发展之道。同时，他也是山东省青年企业家协会的核心成员，致力于推动青年企业家之间的合作与成长。<br />
                    凭借着深厚的行业经验和企业管理经验，邱文伟为济南新域伟网络科技有限公司注入了持续发展的动力。他始终坚持以客户需求为导向，通过不断创新和优化产品与服务，为客户创造更大的价值。<br />
                    在邱文伟的领导下，济南新域伟网络科技有限公司将继续秉承创新、卓越的理念，为客户提供更加优质的服务。同时，他也将带领公司继续探索新的市场机会和技术趋势，为行业的发展做出更大的贡献。
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'aboutUs',
    data() {
        return {
            tabs: ['企业介绍', '企业荣誉', '总经理简介'],
            usIndex: 0,
            scrollTop: 0,
            cerImgs: [
                ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zs9.png'),
                ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zs1.png'),
                ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zs2.png'),
                ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zs3.png'),
                ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zs4.png'),
                ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zs5.png'),
                ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zs6.png'),
                ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zs7.png'),
                ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zs8.png'),
            ]
        }
    },
    created() {

    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
        // 计算距离顶部的高度
        scrollToTop(e) {
            // console.log(e.target.clientHeight, 'e.target.clientHeight');
            // console.log(e.target.scrollHeight, 'e.target.scrollHeight');
            // if (this.$refs.usIntr.getBoundingClientRect().top < 0) {
            //     this.usIndex = 0
            // }
            // if (this.$refs.certificate.getBoundingClientRect().height < this.$refs.certificate.getBoundingClientRect().top < 1) {
            //     this.usIndex = 1
            // }
            // if (this.$refs.bossBox.getBoundingClientRect().top < this.$refs.certificate.getBoundingClientRect().height) {
            //     this.usIndex = 2
            // }

            // if ((this.$refs.certificate.getBoundingClientRect().height / 2)<this.$refs.certificate.getBoundingClientRect().top < 50) {
            //     this.usIndex = 1
            // }
            // if (this.$refs.certificate.getBoundingClientRect().top < (this.$refs.certificate.getBoundingClientRect().height / 2)) {
            //     this.usIndex = 2
            // }
            // var scrollTop =
            //     window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            // let that = this
            // that.scrollTop = scrollTop
            // if (that.scrollTop > 100) {
            //     ; (that.bgColor = 'white'), (that.fontColor = 'black')
            // } else {
            //     ; (that.bgColor = 'black'), (that.fontColor = 'white')
            // }
            // console.log(that.scrollTop)
        },
        usClick(index) {
            this.usIndex = index
            let val = index == 0 ? 'usIntr' : index == 1 ? 'certificate' : index == 2 ? 'bossBox' : ''
            console.log(val, '  this.$refs.val');
            this.scrollToTarget(val)
            // switch (index) {
            //     case 0:
            //         this.$router.replace({ name: "aboutUs" });
            //         window.location.hash = "#us-intr";
            //         break;
            //     case 1:
            //         this.scrollToTarget()
            //         break;
            //     case 2:
            //         this.$router.replace({ name: "aboutUs" });
            //         window.location.hash = "#boss-box";
            //         break;
            //     default:
            //         break;
            // }
        },
        // 滚动 锚点
        scrollToTarget(val) {
            this.$nextTick(() => {
                const target = this.$refs[val];
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
            });
        },
        handleScroll(e) {
            console.log(e);
        }
    }
}
</script>

<style lang="scss" scoped>
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

.container {
    /* width: 1250px; */
    background-color: #F7F8FA;
    /* overflow-y: scroll; */
}

.banner-img {
    height: 522px;
    background: url('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/us-img.png') no-repeat;
    background-size: cover;
    overflow: hidden;

    .b-txt {
        font-weight: 700;
        font-size: 36px;
        color: #0267FE;
        margin: 235px 0 0 260px;
    }
}

.us-tabs {
    position: sticky;
    top: 78px;
    z-index: 11;
    height: 68px;
    border-top: 1px solid #DCDFE6;
    display: flex;
    align-items: center;
    padding-left: 262px;
    box-sizing: border-box;
    background-color: #fff;
    font-size: 16px;
    font-weight: 700;

    .p-item {
        line-height: 68px;
        margin-right: 96px;
        cursor: pointer;
    }

    .p-item-c {
        border-bottom: 3px solid #0267FE;
    }
}

.us-intr {
    position: relative;
    height: 758px;
    background-color: #fff;
    margin-top: 2px;
    padding: 166px 0 0 260px;

    .us-tit {
        font-size: 28px;
        color: #333;
        font-weight: 700;
        margin: 4px 0 24px;
    }

    .us-tip {
        font-size: 18px;
        color: #333;
        margin: 4px 0 24px;
    }

    .us-con {
        width: 725px;

        p:nth-child(2) {
            margin: 25px 0;
        }

        p {
            font-size: 14px;
            color: #666;
            line-height: 23px;
        }
    }

    img {
        width: 932px;
        height: 659px;
        position: absolute;
        right: 0;
        bottom: 0;
    }
}

.certificate {
    height: 1009px;
    background-color: #EAF1FF;
    padding: 0 260px;
    box-sizing: border-box;
    overflow: hidden;

    .certificate-tit {
        text-align: center;
        font-size: 28px;
        color: #333;
        margin: 120px auto 40px;
        font-weight: 700;
    }

    .cer-imgs {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .cer-img:nth-child(1) {
            width: 530px;
            height: 340px;
        }

        .cer-img {
            width: 240px;
            height: 340px;
            margin-bottom: 50px;
        }
    }
}

.boss-box {
    display: flex;
    align-items: center;
    height: 550px;
    background-color: #fff;

    .boss-left {
        width: 780px;
        height: 100%;
        background: url('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/boss.png') no-repeat;
        background-size: cover;
        color: #fff;
        padding: 69px 0 0 345px;
        box-sizing: border-box;

        .b-l-name {
            font-size: 22px;
            font-weight: 700;
            margin-bottom: 8px;
        }

        .b-l-tip {
            font-size: 14px;
        }
    }

    .boss-right {
        margin: 50px 0 80px 124px;

        .b-f-tit {
            font-size: 28px;
            color: #0267FE;
            font-weight: 700;
        }

        .b-f-tip {
            width: 40px;
            height: 2px;
            background: #0267FE;
            margin: 32px 0;
        }

        .b-f-con {
            line-height: 25px;
            width: 867px;
            font-size: 14px;
            color: #333;

            .b-f-con-c {
                margin: 0 46px;
            }
        }
    }
}
</style>
